import { Filters } from '../interfaces';
import { Client } from './interfaces';

export enum ClientsActionType {
  GET_CLIENTS = 'CLIENTS/GET_CLIENTS',
  GET_CLIENTS_SUCCESS = 'CLIENTS/GET_CLIENTS_SUCCESS',
  GET_CLIENTS_ERROR = 'CLIENTS/GET_CLIENTS_ERROR',
  EXPORT_CLIENTS = 'CLIENTS/EXPORT_CLIENTS',
  EXPORT_CLIENTS_SUCCESS = 'CLIENTS/EXPORT_CLIENTS_SUCCESS',
  EXPORT_CLIENTS_ERROR = 'CLIENTS/EXPORT_CLIENTS_ERROR',
  RESET_EXPORT_CLIENTS = 'CLIENTS/RESET_EXPORT_CLIENTS',
  SHOW_EXPORT_CLIENTS = 'CLIENTS/SHOW_EXPORT_CLIENTS',
  DELETE_CLIENT = 'CLIENTS/DELETE_CLIENT',
  DELETE_CLIENT_SUCCESS = 'CLIENTS/DELETE_CLIENT_SUCCESS',
  DELETE_CLIENT_ERROR = 'CLIENTS/DELETE_CLIENT_ERROR',
  SET_CLIENT_DETAIL = 'CLIENTS/SET_CLIENT_DETAIL',
  GET_CLIENTS_SUMMARY = 'CLIENTS/GET_CLIENTS_SUMMARY',
  GET_CLIENTS_SUMMARY_SUCCESS = 'CLIENTS/GET_CLIENTS_SUMMARY_SUCCESS',
  GET_CLIENTS_SUMMARY_ERROR = 'CLIENTS/GET_CLIENTS_SUMMARY_ERROR',
}

export const getClients = (page?: number, filters?: Filters, rowsPerPage?: number) => ({
  type: ClientsActionType.GET_CLIENTS,
  page,
  filters,
  rowsPerPage,
});

export const getClientsSuccess = (response: unknown) => ({
  type: ClientsActionType.GET_CLIENTS_SUCCESS,
  response,
});

export const getClientsError = (error: unknown) => ({
  type: ClientsActionType.GET_CLIENTS_ERROR,
  error,
});

export const exportClients = (filters?: Filters, format?: string) => ({
  type: ClientsActionType.EXPORT_CLIENTS,
  filters,
  format,
});

export const exportClientsSuccess = (response: { text: string }) => ({
  type: ClientsActionType.EXPORT_CLIENTS_SUCCESS,
  response,
});

export const exportClientsError = (error: unknown) => ({
  type: ClientsActionType.EXPORT_CLIENTS_ERROR,
  error,
});

export const resetExportClients = () => ({
  type: ClientsActionType.RESET_EXPORT_CLIENTS,
});

export const showExportClients = (show: boolean) => ({
  type: ClientsActionType.SHOW_EXPORT_CLIENTS,
  show,
});

export const deleteClient = (clientId: number, page?: number, filters?: Filters, rowsPerPage?: number) => ({
  type: ClientsActionType.DELETE_CLIENT,
  clientId,
  page,
  filters,
  rowsPerPage,
});

export const deleteClientSuccess = (clientId: number) => ({
  type: ClientsActionType.DELETE_CLIENT_SUCCESS,
  clientId,
});

export const deleteClientError = (error: unknown) => ({
  type: ClientsActionType.DELETE_CLIENT_ERROR,
  error,
});

export const setClientDetail = (client: Client | null) => ({
  type: ClientsActionType.SET_CLIENT_DETAIL,
  client,
});

export const getClientsSummary = (filters?: Filters) => ({
  type: ClientsActionType.GET_CLIENTS_SUMMARY,
  filters,
});

export const getClientsSummarySuccess = (summary: unknown) => ({
  type: ClientsActionType.GET_CLIENTS_SUMMARY_SUCCESS,
  summary,
});

export const getClientsSummaryError = () => ({
  type: ClientsActionType.GET_CLIENTS_SUMMARY_ERROR,
});
